import { render } from "./BalanceSheet.vue?vue&type=template&id=51c87346&scoped=true"
import script from "./BalanceSheet.vue?vue&type=script&lang=js"
export * from "./BalanceSheet.vue?vue&type=script&lang=js"

import "./BalanceSheet.vue?vue&type=style&index=0&id=51c87346&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c87346"]])

export default __exports__